import { normalizeExpenseType } from "../lib/expenseType.js";

export function buildExpenseSearchText(row, expenseTypeLabels, expenseGridColumns) {
  const safeRow = row ?? {};
  const monthColumn = expenseGridColumns.find((column) => column.key === "dateMonth");
  const visibleMonthLabel = monthColumn?.displayValue?.(safeRow) ?? "";

  return [
    safeRow.date,
    visibleMonthLabel,
    safeRow.amount,
    safeRow.method,
    safeRow.type,
    expenseTypeLabels[normalizeExpenseType(safeRow.type)] ?? safeRow.type,
    safeRow.supplier,
    safeRow.category,
    safeRow.service
  ]
    .map((value) => String(value ?? "").toLocaleLowerCase())
    .join(" ");
}
